export interface SonicGameSelectionItem {
  id: string;
  value: string;
}

export interface SonicGameSelectionData {
  id: string;
  game_id: string;
  rank: Array<SonicGameSelectionItem>;
}

export class SonicGameSelection implements SonicGameSelectionData {
  id: string;
  game_id: string;
  rank: Array<SonicGameSelectionItem>;

  constructor(
    id: string,
    game_id: string,
    rank: Array<SonicGameSelectionItem>
  ) {
    this.id = id;
    this.game_id = game_id;
    this.rank = rank;
  }

  static parseFromAPIResponse(item: any) {
    return new SonicGameSelection(item.id, item.game_id, item.rank);
  }
}
